import { getRgObjectsOfType as p, RG_TYPE as l } from "@project-rouge/rg-core";
import { getLevelCount as i } from "../object-helpers/index3.js";
import { getLevelApartmentTypeCounts as m } from "./index4.js";
const f = (t) => {
  const o = [], n = p(t, l.Building), r = i(n, !1);
  for (let e = 0; e < r; e++) {
    const s = m(t, e);
    o.push({ i: e, mix: s });
  }
  return o;
};
export {
  f as getLevelArrayApartmentTypeCounts
};
//# sourceMappingURL=index6.js.map
